import * as types from '../mutation-types'
import { API } from '../../api'
import { UTILS } from '../../utils'

export default {
    namespaced: true,
    state: {
      className: '',
      titleText: '',
      dateInfo: {month: "", day: "", week: "", gzYMD: {year: "年", month: "月", day: "日"}},
      totalInfo: {imgUrl: "", colorArr: [{}, {}, {}]},
      colorArr: [],
    },
    getters: {},
    mutations: {
    },
    actions: {
        initDressData({ state }, params) {
            API.getDressPageInfo(params, (data)=> {
                console.log('获取五行穿衣首页信息成功------', data)
                // 今天日子的主要信息
                let wxIndex = data.wx-1;
                state.className = UTILS.getWxClassByIndex(wxIndex);
                state.titleText = UTILS.getWxTextByIndex(wxIndex);
                let gzYMD = UTILS.getGzYMDByArr(data.time.tg, data.time.dz);
                state.dateInfo = Object.assign({
                    month: data.time.calendar[1]+'月',
                    day: data.time.calendar[2],
                    week: '星 期 '+UTILS.getWeekTextByDay(parseInt(data.time.week))
                }, {gzYMD: gzYMD});
                // totalInfo里的样式信息
                let colorArr = UTILS.getColorArrByArr(data.rankInfo);
                state.colorArr = colorArr;
                state.totalInfo = Object.assign({
                    imgUrl: data.banner,
                    colorArr: colorArr
                });

            })
        },
        resetData({ state }){
            state.totalNum = 0;
            state.myNum = 0;
            state.productList = [];
            state.donateSuccess = false;
        }
    }
}